import sha1 from 'sha1';

import React, { useState, useEffect, useContext } from 'react';
import { DcContext } from './context';


const Login = (props) => {

	// * state 
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [password, setPassword] = useState("");
	const [passwordError, setPasswordError] = useState(false);

	// * context 
	const appContext = useContext(DcContext);	

	// * helpers 
	const setLoginState = (loggedIn) => {
		setIsLoggedIn(loggedIn);
		// update context
		appContext.setIsLoggedIn(loggedIn);
		// reset formstate 
		// const formState = appContext.getFormState();
		// formState.resetOffer();
	}

	// * component mount/update
	useEffect(
		() => {
			//console.log('login',  props.hashValue); 
			setPassword(props.hashValue);
			const loggedIn = appContext.getIsLoggedIn()
			setIsLoggedIn(loggedIn); 
		},
		[props]
	);

	// * events
	const updatePassword = (evt) => {
		setPassword(evt.target.value);
	}
	const login = (evt) => {
		evt.preventDefault();
		const appPassword = props.hashValue;
		const userPassword = sha1(password);
		//console.log('login', appPassword, userPassword);
		const loggedIn = (appPassword === userPassword);
		setPasswordError(!loggedIn);
		setLoginState(loggedIn);
		// google analytics
		if (loggedIn) {
			gtag('event', 'login', {
				"app" : props.appId
			});
		}
	}
	const passwordKeyDown = (evt) => {
		setPassword(evt.target.value);
		if (evt.keyCode && evt.keycode == 13) {
			login(evt);
		}
	}	

	// * render 
	return (
		<form name='login-form' className='login-form'>
			{ props.hashValue ? 
				<div>
					<div className='form-group'>
						<label htmlFor='dcPassword'>Password:</label>
						<input type='password' name='dcPassword' id='dcPassword'
							placeholder='Password'
							className={"form-control " + (passwordError ? "error" : "")}
							onBlur={updatePassword}
							onKeyDown={passwordKeyDown} />
						<p className={"error-msg " + (passwordError ? "error" : "")}>incorrect password</p>
					</div>
					<div className='form-group'>
						<button className='btn btn-primary btn-disclaimer btn-login' onClick={login}>Go</button>
					</div>
				</div> 
			: <div>...</div>}	

			<div className="login-note">please disable ad-blockers</div>
		</form>
	);

}

export default Login;
